import { render, staticRenderFns } from "./LayoutEditBuildingsTab.vue?vue&type=template&id=a87aa97c"
import script from "./LayoutEditBuildingsTab.vue?vue&type=script&lang=ts"
export * from "./LayoutEditBuildingsTab.vue?vue&type=script&lang=ts"
import style0 from "./LayoutEditBuildingsTab.vue?vue&type=style&index=0&id=a87aa97c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports